import { data } from '../../svg/Call/data';
import { makeIcon } from '../makeIcon';

export const Call = makeIcon(data, 'call', 'Call');

export default Call;
